import { render, staticRenderFns } from "./listaProyectos.vue?vue&type=template&id=668d921c"
import script from "./listaProyectos.vue?vue&type=script&lang=js"
export * from "./listaProyectos.vue?vue&type=script&lang=js"
import style0 from "./listaProyectos.vue?vue&type=style&index=0&id=668d921c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports